import { forwardRef,useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Link, Stack, styled, Typography } from '@mui/material';
import { Modal, modalModel } from 'entities/modal';
import { profileModel } from 'entities/profile';
import { profileActions } from 'entities/profile/model';
import { userModel } from 'entities/user';
import { userActions } from 'entities/user/model';
import QRCode from 'react-qr-code';
import {
  BORDER_RADIUS_S,
  BORDER_S,
  checkRequestStatusEquality,
  COLOR_ACCENT,
  RequestStatus,
  uiSelector,
  useShallowSelector,
  useWalletConnectorContext,
  Icon,
  ProgressBar,
  levelTitles,
  COLOR_TEXT_GRAY
} from 'shared';

import { ModalWrapper } from '../ModalWrapper';

export interface ScoreModalPayload {
  type: modalModel.Modals.ScoreModal;
  data: null;
}

const UpdateButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: '30px',
  backgroundColor: '#281447',
  // ...theme.typography.subtitle2,
  // ...interactButtons,
  // borderColor: theme.themeColors.colorBorder,
  margin: theme.spacing(5, 0),
  // background: theme.themeColors.colorBackground,
}));

export const ScoreModal = forwardRef<HTMLElement, Modal>(() => {
  const dispatch = useDispatch();
  const { score: rScore, isCurrentUser } = useShallowSelector(profileModel.selectors.getProfile);

  const { score } = rScore;

  let mintButtonContent;

  return (
    <ModalWrapper title="" font="secondary" fontWeight="normal" size="sm">
     
      <Box display="flex" flexDirection="column" justifyContent="flex-start" width="100%" mx="auto">
        <Stack width="100%" flexDirection="row" justifyContent="center" alignItems="center" pb="30px"><Icon type="dfinity" size="medium" /><Typography sx={{paddingLeft: '10px'}} variant="h2">SCORE</Typography></Stack>

        <Stack>
              <Stack direction="row" justifyContent="center">
                <Typography variant="h1" color={COLOR_TEXT_GRAY}>
                  {Math.floor(score)}/20
                </Typography>
              </Stack>
              <ProgressBar sx={{width: '100%', height: '10px', margin: '20px 0'}} >
                {/* percentageValue
                    width=`${value}%` */}
                <Box width={`${score * 5}%`} />
              </ProgressBar>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', margin: '0 auto!important', width: '98%', }}>
                <Typography fontSize="15px!important">LVL</Typography>
                <Typography fontSize="15px!important">
                  {score > 20 ? 2 : `${Math.floor(score / 10) + 1 || 0}/${levelTitles.length}`}
                </Typography>
              </Box>
        </Stack>

        {isCurrentUser && <UpdateButton
          variant="contained"
          onClick={() => {
            dispatch(profileActions.updateProfileScore());
          }}
        >
          update
        </UpdateButton>}

      </Box>
        <Stack spacing={2.5} mt={2} mb={5} height="100%" width="70%" mx="auto">
          <Stack direction="row" justifyContent="center">
            <Typography align="center" color="#000">
              This is <span style={{ fontWeight: 'bold' }}>your ICP score</span> that represents your <span style={{ fontWeight: 'bold' }}> web3 nativity.</span>
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="center">
            <Typography align="center" color="#000">
              It is based on various credentials and on-chain data.
            </Typography>
          </Stack>
        </Stack>
    </ModalWrapper>
  );
});

ScoreModal.displayName = 'ScoreModal';
